import { VACAeroDashboardOperatorPerformance } from './vacaero-components/VACAeroDashboardOperatorPerformance';

export const VACAeroDashboard = () => {
  return (
    <VACAeroDashboardOperatorPerformance />
  );
};